"use strict";
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const router_1 = require("@angular/router");
const motion_component_1 = require("./motion/motion.component");
const routes = [
    {
        path: 'motion',
        children: [
            { path: ':unit/:plc/:entries', component: motion_component_1.MotionComponent },
            { path: ':unit/:plc', component: motion_component_1.MotionComponent },
            { path: ':unit', component: motion_component_1.MotionComponent },
        ]
    }
];
exports.MOTION_ROUTES = router_1.RouterModule.forChild(routes);
